import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['showOnFailure'];

  handleFailure(event) {
    let messages = ['Wir konnten dich nicht anmelden.'];
    let errorMessages = event.detail[0].messages || [];
    messages = messages.concat(errorMessages.map((value) => `- ${value}`));
    this.showOnFailureTarget.innerHTML = messages.join('\n<br/>');
    this.showOnFailureTarget.classList.remove('hidden');
  }
}
